import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useField } from 'formik'
import { Menu, MenuItem } from '@material-ui/core'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import { compose, find, prop, propEq } from 'ramda'

const SelectorV2Formik = ({ label, name, options, disabled = false }) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const [field, meta, helpers] = useField(name)
  const { value } = field
  const { setValue } = helpers

  const isError = !!meta.error && meta.touched

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleMenuClose = (option) => {
    setValue(option)
    setAnchorEl(null)
  }

  const getLabel = (value) => {
    return compose(prop('label'), find(propEq('value', value)))(options)
  }

  return (
    <div>
      <button
        type="button"
        onClick={handleMenuClick}
        disabled={disabled}
        className={`flex items-center w-full h-48 px-4 border rounded-8 text-left justify-between ${
          isError ? 'border-red-500' : 'border-grey-input'
        } ${
          disabled
            ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
            : 'bg-white text-black hover:border-gray-400'
        }`}
      >
        <span className="p-5 text-blue-950  text-14">
          {getLabel(value) || <label className="opacity-50">{label}</label>}
        </span>

        <ArrowDropDownIcon className="ml-2 text-gray-500" />
      </button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        {options.map((option, index) => (
          <MenuItem
            key={index}
            className="w-320"
            onClick={() => handleMenuClose(option.value)}
            selected={value === option.value}
          >
            {option.label}
          </MenuItem>
        ))}
      </Menu>

      {isError && (
        <div style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>
          {meta.error}
        </div>
      )}
    </div>
  )
}

SelectorV2Formik.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
    }),
  ).isRequired,
  disabled: PropTypes.bool,
}

export default SelectorV2Formik
